import { render, staticRenderFns } from "./OrderFormScreen.vue?vue&type=template&id=00dfb590&"
import script from "./OrderFormScreen.vue?vue&type=script&lang=ts&"
export * from "./OrderFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports